(function () {
  // category = Shopify standard product category (snippets/collection-filter-categories), handled like a metafield.
  var MF_KEYS = ['design_style', 'appearance', 'with_gemstones', 'massiveness', 'weight', 'seasons', 'holidays', 'category', 'material'];

  function panel() {
    return document.getElementById('collection-filter-panel');
  }

  function openPanel() {
    var el = panel();
    if (!el) return;
    el.hidden = false;
    el.offsetWidth;
    el.classList.add('is-open');
    document.body.classList.add('collection-filter-open');
    var btn = document.getElementById('toolbar-filter-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    refreshFilterCounts();
  }

  function closePanel() {
    var el = panel();
    if (!el) return;
    syncAllChecks(cfHandlesFromUrl(), cfStonesFromUrl(), cfMetafieldsFromUrl());
    el.classList.remove('is-open');
    document.body.classList.remove('collection-filter-open');
    var btn = document.getElementById('toolbar-filter-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      if (el.classList.contains('is-open')) return;
      el.hidden = true;
    }, 320);
  }

  function cfContext() {
    var t = document.body.getAttribute('data-template') || '';
    if (t === 'search' || t === 'collection.all' || t.indexOf('collection.all') === 0) return true;
    return !!document.querySelector('.cf-filter-groups');
  }

  function selectedHandles(root) {
    var handles = [];
    if (!root) return handles;
    root.querySelectorAll('[data-cf-handle].active-filter').forEach(function (el) {
      var h = el.getAttribute('data-cf-handle');
      if (h && h !== 'all' && h !== 'all-products') handles.push(h);
    });
    return handles;
  }

  function selectedStones(root) {
    var stones = [];
    var el = root || panel();
    if (!el) return stones;
    el.querySelectorAll('[data-cf-stone].active-filter').forEach(function (node) {
      var s = node.getAttribute('data-cf-stone');
      if (s) stones.push(s);
    });
    return stones;
  }

  function isGemAllValue(v) {
    return !v || v === 'all' || v === 'all-gem';
  }

  function selectedMetafields(root) {
    var out = {};
    var el = root || panel();
    if (!el) return out;
    el.querySelectorAll('[data-cf-mf-key][data-cf-mf-value].active-filter').forEach(function (node) {
      var k = node.getAttribute('data-cf-mf-key');
      var v = node.getAttribute('data-cf-mf-value');
      if (!k || v == null || v === '') return;
      if (k === 'with_gemstones' && isGemAllValue(v)) return;
      if (!out[k]) out[k] = [];
      if (out[k].indexOf(v) === -1) out[k].push(v);
    });
    return out;
  }

  function hasMf(mf) {
    if (!mf) return false;
    return MF_KEYS.some(function (k) { return mf[k] && mf[k].length; });
  }

  function mfValueCount(mf) {
    var n = 0;
    if (!mf) return n;
    MF_KEYS.forEach(function (k) { if (mf[k]) n += mf[k].length; });
    return n;
  }

  function cfMetafieldsFromUrl() {
    var out = {};
    try {
      var url = new URL(window.location.href);
      MF_KEYS.forEach(function (k) {
        var vals = (url.searchParams.get(k) || '').split(/[+\s]/).filter(function (v) { return String(v).length > 0; });
        if (k === 'with_gemstones') {
          vals = vals.filter(function (v) { return !isGemAllValue(v); });
        }
        if (vals.length) out[k] = vals;
      });
    } catch (e) {}
    return out;
  }

  function gemstonesWanted(mf) {
    var vals = mf && mf.with_gemstones;
    if (!vals || !vals.length) return 'all';
    if (vals.indexOf('has-gem') !== -1 || vals.indexOf('true') !== -1) return 'has-gem';
    if (vals.indexOf('no-gem') !== -1 || vals.indexOf('false') !== -1) return 'no-gem';
    return 'all';
  }

  function syncGemstonesRadio(mf) {
    var wanted = gemstonesWanted(mf);
    filterRoots().forEach(function (el) {
      el.querySelectorAll('[data-cf-mf-key="with_gemstones"]').forEach(function (node) {
        var v = node.getAttribute('data-cf-mf-value');
        var on = v === wanted || (wanted === 'all' && isGemAllValue(v));
        setChecked(node, on);
      });
    });
  }

  function filterRoots() {
    var roots = [];
    var main = panel();
    var side = document.querySelector('.layernavigation-module');
    if (main) roots.push(main);
    if (side) roots.push(side);
    return roots;
  }

  function syncMfChecks(mf) {
    filterRoots().forEach(function (el) {
      el.querySelectorAll('[data-cf-mf-key][data-cf-mf-value]').forEach(function (node) {
        var k = node.getAttribute('data-cf-mf-key');
        if (k === 'with_gemstones') return;
        var v = node.getAttribute('data-cf-mf-value');
        var on = !!(mf && mf[k] && mf[k].indexOf(v) !== -1);
        setChecked(node, on);
      });
    });
    syncGemstonesRadio(mf);
  }

  function stripFilterParams(url) {
    url.searchParams.delete('cf');
    url.searchParams.delete('st');
    MF_KEYS.forEach(function (k) { url.searchParams.delete(k); });
    return url;
  }

  function cfStonesFromUrl() {
    try {
      return (new URL(window.location.href).searchParams.get('st') || '')
        .split(/[+\s]/)
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function syncStoneChecks(stones) {
    filterRoots().forEach(function (el) {
      el.querySelectorAll('[data-cf-stone]').forEach(function (node) {
        setChecked(node, stones.indexOf(node.getAttribute('data-cf-stone')) !== -1);
      });
    });
  }

  function sameFilterList(a, b) {
    a = (a || []).slice().sort();
    b = (b || []).slice().sort();
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function selectionMatchesApplied(handles, stones, mf) {
    if (!sameFilterList(handles, cfHandlesFromUrl())) return false;
    if (!sameFilterList(stones, cfStonesFromUrl())) return false;
    var appliedMf = cfMetafieldsFromUrl();
    mf = mf || {};
    for (var i = 0; i < MF_KEYS.length; i++) {
      var k = MF_KEYS[i];
      if (!sameFilterList(mf[k], appliedMf[k])) return false;
    }
    return true;
  }

  function updateApplyCount() {
    var source = panel() || document.querySelector('.layernavigation-module');
    if (!source) return;
    var handles = selectedHandles(source);
    var stones = selectedStones(source);
    var mf = selectedMetafields(source);
    var n = handles.length + stones.length + mfValueCount(mf);
    var applied = n > 0 && selectionMatchesApplied(handles, stones, mf);
    document.querySelectorAll('[data-filter-apply]').forEach(function (btn) {
      var badge = btn.querySelector('[data-filter-apply-count]');
      var label = btn.querySelector('[data-filter-apply-label]');
      btn.disabled = !n || applied;
      btn.classList.toggle('is-applied', applied);
      if (label) {
        label.textContent = applied
          ? (label.getAttribute('data-applied-label') || 'Applied')
          : (label.getAttribute('data-apply-label') || 'Apply');
      }
      if (!badge) return;
      if (n > 0) {
        badge.hidden = false;
        badge.textContent = String(n);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
    if (countsVisible()) refreshFilterCounts();
    updateStickyBar(n);
  }

  // Sticky Clear / Apply bar (wide screens, snippets/collection-sidebar): up while something is ticked
  // and the sidebar's own buttons are off screen.
  var cfStickyCount = 0;
  var cfSideActionsInView = false;

  function updateStickyBar(n) {
    if (n != null) cfStickyCount = n;
    var bar = document.querySelector('[data-cf-sticky]');
    if (!bar) return;
    var side = document.querySelector('.layernavigation-module .cf-filter-actions');
    var on = cfStickyCount > 0 && !!side && side.offsetParent !== null && !cfSideActionsInView
      && !document.body.classList.contains('collection-filter-open');
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function watchSideActions() {
    var side = document.querySelector('.layernavigation-module .cf-filter-actions');
    if (!side || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      cfSideActionsInView = entries[0].isIntersecting;
      updateStickyBar();
    }).observe(side);
  }

  function setChecked(link, on) {
    link.classList.toggle('active-filter', on);
    link.setAttribute('aria-checked', on ? 'true' : 'false');
  }

  function setCheckedMatch(selector, on) {
    filterRoots().forEach(function (root) {
      root.querySelectorAll(selector).forEach(function (node) { setChecked(node, on); });
    });
  }

  function togglePanelHandle(link) {
    var h = link.getAttribute('data-cf-handle');
    if (!h) return;
    setCheckedMatch('[data-cf-handle="' + h + '"]', !link.classList.contains('active-filter'));
    updateApplyCount();
  }

  function cfHandlesFromUrl() {
    try {
      return (new URL(window.location.href).searchParams.get('cf') || '')
        .split(/[+\s]/)
        .filter(function (h) { return h && h !== 'all' && h !== 'all-products'; });
    } catch (e) {
      return [];
    }
  }

  function syncChecks(handles) {
    var roots = [panel(), document.querySelector('.layernavigation-module')];
    roots.forEach(function (root) {
      if (!root) return;
      root.querySelectorAll('[data-cf-handle]').forEach(function (el) {
        var h = el.getAttribute('data-cf-handle');
        setChecked(el, handles.indexOf(h) !== -1);
      });
    });
  }

  function syncAllChecks(handles, stones, mf) {
    syncChecks(handles);
    syncStoneChecks(stones);
    syncMfChecks(mf);
    updateApplyCount();
  }

  var cfSnapshot = null;
  var cfMergedCards = [];
  var cfPageSize = 30;
  var cfCardCache = {};
  var cfResolvedCards = {};
  var cfPageLoadGen = 0;
  // Cards of the server-rendered page, captured before any filter touches the grid.
  // Null when the server already narrowed the page by ?cf=, so they cannot seed the full listing.
  var cfInitialCards = null;
  var cfInitialView = null;
  // True while the grid shows a filtered result instead of a plain listing page.
  var cfGridFiltered = false;
  var cfGridPage = 1;

  function setCfLoading(on) {
    var w = document.getElementById('wraper_ajax');
    if (w) w.style.display = on ? 'block' : 'none';
  }

  // Spinner over real cards only: while skeletons are on screen (page skeleton before .grid-ready, or ours)
  // they already say "loading".
  function showSoftLoading() {
    if (!document.body.classList.contains('grid-ready')) return;
    if (document.querySelector('.grid-real .skeleton-item')) return;
    setCfLoading(true);
  }

  function isSearchPage() {
    return (document.body.getAttribute('data-template') || '') === 'search';
  }

  function previewParams(url) {
    var src = new URL(window.location.href);
    var preview = src.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  function snapshotGrid() {
    if (cfSnapshot || cfGridFiltered) return;
    var grid = document.querySelector('.grid-real');
    var pager = document.getElementById('pagination');
    var layouts = grid ? grid.querySelectorAll('.product-layout') : [];
    if (layouts.length) cfPageSize = layouts.length;
    cfSnapshot = {
      page: cfGridPage,
      grid: grid ? grid.innerHTML : '',
      pager: pager ? pager.innerHTML : '',
      amounts: Array.prototype.map.call(document.querySelectorAll('.toolbar-amount'), function (el) {
        return el.innerHTML;
      })
    };
  }

  function markGridFiltered() {
    snapshotGrid();
    cfGridFiltered = true;
  }

  function restoreGrid() {
    if (!cfSnapshot) return;
    cfGridFiltered = false;
    cfGridPage = cfSnapshot.page;
    var grid = document.querySelector('.grid-real');
    if (grid) grid.innerHTML = cfSnapshot.grid;
    var pager = document.getElementById('pagination');
    if (pager) { pager.classList.remove('cf-pager-empty'); pager.innerHTML = cfSnapshot.pager; }
    document.querySelectorAll('.toolbar-amount').forEach(function (el, i) {
      if (cfSnapshot.amounts[i] != null) el.innerHTML = cfSnapshot.amounts[i];
    });
    cfSnapshot = null;
    cfMergedCards = [];
  }

  function cardProductHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Listing pages are fetched through a small queue so a large catalog does not fire dozens of requests at once.
  var CF_FETCH_LIMIT = 4;
  var cfFetchQueue = [];
  var cfFetchActive = 0;

  function pumpFetchQueue() {
    while (cfFetchActive < CF_FETCH_LIMIT && cfFetchQueue.length) cfFetchQueue.shift()();
  }

  function fetchQueued(url) {
    return new Promise(function (resolve, reject) {
      cfFetchQueue.push(function () {
        cfFetchActive += 1;
        fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('fetch failed: ' + r.status);
          return r.text();
        }).then(resolve, reject).then(function () {
          cfFetchActive -= 1;
          pumpFetchQueue();
        });
      });
      pumpFetchQueue();
    });
  }

  function fetchDoc(url) {
    return fetchQueued(url).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  // Collection membership straight from the collections (templates/collection.cf-handles.liquid):
  // product.collections on the cards comes back incomplete, which zeroed most collection counts.
  var CF_MEMBERS_KEY = 'cfMembers2';
  var cfMembership = null;

  function filterCollectionHandles() {
    var out = [];
    filterRoots().forEach(function (root) {
      root.querySelectorAll('[data-cf-handle]').forEach(function (node) {
        var h = node.getAttribute('data-cf-handle');
        if (h && out.indexOf(h) === -1) out.push(h);
      });
    });
    return out;
  }

  function fetchCollectionMembers(handle) {
    var list = [];
    function page(p) {
      var url = new URL('/collections/' + encodeURIComponent(handle), window.location.origin);
      url.searchParams.set('view', 'cf-handles');
      if (p > 1) url.searchParams.set('page', String(p));
      previewParams(url);
      return fetchQueued(url).then(function (text) {
        var data = JSON.parse(text);
        list.push.apply(list, data.handles || []);
        return data.page < data.pages ? page(p + 1) : list;
      });
    }
    return page(1);
  }

  // { collectionHandle: [productHandle, ...] }. A collection that fails to load is left out,
  // and its cards keep whatever data-cf-collections the server printed.
  function fetchMembership() {
    if (cfMembership) return cfMembership;
    var handles = filterCollectionHandles();
    try {
      var cached = JSON.parse(sessionStorage.getItem(CF_MEMBERS_KEY) || 'null');
      if (cached && handles.every(function (h) { return cached[h]; })) {
        cfMembership = Promise.resolve(cached);
        return cfMembership;
      }
    } catch (e) {}
    cfMembership = Promise.all(handles.map(function (h) {
      return fetchCollectionMembers(h).then(function (list) {
        return [h, list];
      }, function (err) {
        if (window.console) console.warn('[filters] membership of "' + h + '" not loaded, counts for it fall back to card data', err);
        return [h, null];
      });
    })).then(function (pairs) {
      var map = {};
      var complete = true;
      pairs.forEach(function (pair) {
        if (pair[1]) map[pair[0]] = pair[1];
        else complete = false;
      });
      if (complete) {
        try {
          sessionStorage.setItem(CF_MEMBERS_KEY, JSON.stringify(map));
        } catch (e) {}
      }
      return map;
    });
    return cfMembership;
  }

  function applyMembership(cards, map) {
    var byProduct = {};
    Object.keys(map).forEach(function (col) {
      map[col].forEach(function (ph) {
        (byProduct[ph] = byProduct[ph] || []).push(col);
      });
    });
    cards.forEach(function (card) {
      var own = cardCollections(card).filter(function (h) { return !map[h]; });
      var cols = own.concat(byProduct[cardProductHandle(card)] || []);
      card.setAttribute('data-cf-collections', cols.join(' '));
    });
  }

  // Search shows only products whose title, type or tags contain every query word
  // (data-cf-match, set in search-result-grid). If nothing matches strictly, the full Shopify result stays.
  function strictSearchCards(cards) {
    if (!isSearchPage()) return cards;
    var strict = cards.filter(function (card) { return card.getAttribute('data-cf-match') === '1'; });
    return strict.length ? strict : cards;
  }

  function paintSearchTitle(total) {
    // Blog search (type=article) has no product grid: keep Shopify's own article count.
    if (!document.querySelector('.custom-category')) return;
    document.querySelectorAll('[data-cf-search-title]').forEach(function (el) {
      el.textContent = (el.textContent || '').replace(/\d[\d,.\s]*/, String(total) + ' ');
    });
  }

  function listingSectionId() {
    var wrap = document.querySelector('.custom-category[data-cf-section-id]');
    return wrap ? wrap.getAttribute('data-cf-section-id') : '';
  }

  // One page of the current listing (collection or search) with filters stripped.
  // With section_id Shopify returns only the section HTML: no header, mega menu, footer or scripts.
  function listingPageUrl(page, sectionId, sort) {
    var url = new URL(window.location.href);
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    if (sort) url.searchParams.set('sort_by', sort);
    else url.searchParams.delete('sort_by');
    stripFilterParams(url);
    url.searchParams.set('cf_cards', '1');
    if (sectionId) url.searchParams.set('section_id', sectionId);
    else url.searchParams.delete('section_id');
    return previewParams(url);
  }

  function fetchListingPageDoc(page, sort) {
    var sectionId = listingSectionId();
    var full = function () { return fetchDoc(listingPageUrl(page, '', sort)); };
    if (!sectionId) return full();
    return fetchDoc(listingPageUrl(page, sectionId, sort)).catch(full);
  }

  function targetColClasses() {
    var wrap = document.querySelector('.custom-category');
    // Source of truth: snippets/grid-col-class.liquid, rendered into data-cf-col-class.
    var fromLiquid = wrap ? (wrap.getAttribute('data-cf-col-class') || '').trim() : '';
    if (fromLiquid) return fromLiquid;
    var view = wrap ? wrap.getAttribute('data-cf-view') : '';
    if (view === '3') return 'col-lg-4 col-md-4 col-sm-4 col-xs-4';
    if (view === '5') return 'col-lg-divide-5 col-md-divide-5 col-sm-6 col-xs-6';
    if (view === '0') return 'col-xs-12';
    return 'col-lg-3 col-md-3 col-sm-6 col-xs-6';
  }

  function restyleGridCards() {
    var cols = targetColClasses();
    var wrap = document.querySelector('.custom-category');
    var view = wrap ? wrap.getAttribute('data-cf-view') : '';
    var colRe = /\bcol-(?:lg|md|sm|xs)(?:-divide)?-\S+/g;
    document.querySelectorAll('.grid-real .product-layout').forEach(function (el) {
      el.className = el.className.replace(colRe, '').replace(/\s+/g, ' ').trim();
      if (view === '0') {
        el.classList.remove('product-grid');
        el.classList.add('product-list');
      } else {
        el.classList.remove('product-list');
        el.classList.add('product-grid');
      }
      el.className = (el.className + ' ' + cols).replace(/\s+/g, ' ').trim();
    });
  }

  function amountHtml(page, size, total) {
    var startN = total ? (page - 1) * size + 1 : 0;
    var endN = Math.min(page * size, total);
    return '<span>Showing <span class="font-weight-500">' + startN + '</span> to <span class="font-weight-500">' + endN + '</span> of <span class="font-weight-500">' + total + '</span> items</span>';
  }

  function paintAmount(html) {
    document.querySelectorAll('.toolbar-amount').forEach(function (el) {
      el.innerHTML = html;
    });
  }

  // Pager links in a fetched page carry the fetch-only params; strip them so open-in-new-tab gets the real page.
  function cleanPagerLinks(pager) {
    pager.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), window.location.origin);
        u.searchParams.delete('section_id');
        u.searchParams.delete('cf_cards');
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }

  function fillGridFromDoc(doc, page) {
    var srcGrid = doc.querySelector('.grid-real');
    var destGrid = document.querySelector('.grid-real');
    if (srcGrid && destGrid) destGrid.innerHTML = srcGrid.innerHTML;
    var srcPager = doc.querySelector('#pagination');
    var destPager = document.getElementById('pagination');
    if (destPager) {
      destPager.innerHTML = srcPager ? srcPager.innerHTML : '';
      destPager.classList.remove('cf-pager-empty');
      cleanPagerLinks(destPager);
    }
    var srcAmount = doc.querySelector('.toolbar-amount');
    if (srcAmount) {
      paintAmount(srcAmount.innerHTML);
    } else {
      var meta = readGridMeta(doc);
      if (meta.total) paintAmount(amountHtml(page || 1, meta.pageSize, meta.total));
    }
    restyleGridCards();
    if (window.category_view && typeof category_view.afterGridHtmlChanged === 'function') {
      category_view.afterGridHtmlChanged(false);
    }
  }

  function scrollToProductGrid() {
    var el = document.getElementById('product-filter')
      || document.querySelector('.toolbar-products:not(.toolbar-bottom)')
      || document.getElementById('custom-products');
    if (!el) return;
    var bar = document.querySelector('header .fix') || document.querySelector('header');
    var headerH = bar ? bar.getBoundingClientRect().height : 0;
    var top = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerH - 25);
    if (window.jQuery) {
      window.jQuery('body,html').stop(true).animate({ scrollTop: top }, 800);
    } else {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function setPageInUrl(page, push) {
    var url = new URL(window.location.href);
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    url.searchParams.delete('cf_cards');
    if (!window.history) return;
    if (push && window.history.pushState) window.history.pushState({ cfAjaxPage: page }, '', url.toString());
    else if (window.history.replaceState) window.history.replaceState({ cfAjaxPage: page }, '', url.toString());
  }

  function pageFromPagerLink(link) {
    var cfPage = link.getAttribute('data-cf-page');
    if (cfPage) return parseInt(cfPage, 10) || 1;
    try {
      return parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10) || 1;
    } catch (err) {
      return 1;
    }
  }

  function currentSort() {
    try {
      return new URL(window.location.href).searchParams.get('sort_by') || '';
    } catch (e) {
      return '';
    }
  }

  // Key of the loaded card set. It does not depend on the sort: cards are loaded once in whatever order
  // was current, and other sorts only fetch the order of handles (see fetchOrderedCards).
  function listingCacheKey() {
    return isSearchPage() ? '__search' : currentAllHandle();
  }

  var cfUniverseSort = {};
  var cfOrders = {};
  var cfOrdersReady = {};

  function fetchSortOrder(sort) {
    var okey = listingCacheKey() + '|' + sort;
    if (cfOrders[okey]) return cfOrders[okey];
    var list = [];
    function page(p) {
      var url = new URL(window.location.href);
      stripFilterParams(url);
      ['page', 'section_id', 'cf_cards'].forEach(function (k) { url.searchParams.delete(k); });
      url.searchParams.set('view', 'cf-handles');
      if (sort) url.searchParams.set('sort_by', sort);
      else url.searchParams.delete('sort_by');
      if (p > 1) url.searchParams.set('page', String(p));
      previewParams(url);
      return fetchQueued(url).then(function (text) {
        var data = JSON.parse(text);
        list.push.apply(list, data.handles || []);
        return data.page < data.pages ? page(p + 1) : list;
      });
    }
    cfOrders[okey] = page(1).then(function (handles) {
      cfOrdersReady[okey] = handles;
      return handles;
    }, function (err) {
      delete cfOrders[okey];
      throw err;
    });
    return cfOrders[okey];
  }

  function orderCards(cards, handles) {
    var rank = {};
    handles.forEach(function (h, i) { if (!(h in rank)) rank[h] = i; });
    return cards.map(function (card, i) {
      var h = cardProductHandle(card);
      return { card: card, r: h in rank ? rank[h] : handles.length + i };
    }).sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.card; });
  }

  // The loaded cards in the current sort, or null when that needs a request.
  function readyOrderedCards() {
    var key = listingCacheKey();
    var cards = cfResolvedCards[key];
    if (!cards) return null;
    var sort = currentSort();
    if (cfUniverseSort[key] === sort) return cards;
    var order = cfOrdersReady[key + '|' + sort];
    return order ? orderCards(cards, order) : null;
  }

  function fetchOrderedCards() {
    var sort = currentSort();
    return fetchListingCards().then(function (cards) {
      if (cfUniverseSort[listingCacheKey()] === sort) return cards;
      return fetchSortOrder(sort).then(function (order) {
        return orderCards(cards, order);
      }, function () {
        return cards;
      });
    });
  }

  // Sorting on filter pages: show the listing in the new order and keep the current filters.
  // The legacy ajax in collection-sorting.liquid re-inserts the sidebar via jQuery, which breaks its inline scripts.
  window.cfHandleSort = function (sortBy) {
    if (!cfContext() || !document.querySelector('.grid-real')) return false;
    var url = new URL(window.location.href);
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    if (window.history && window.history.pushState) window.history.pushState({ cfSort: sortBy }, '', url.toString());
    cfMergedCards = [];
    applyPaginationPage(1, false);
    return true;
  };

  function syncSortSelect() {
    var sel = document.getElementById('input-sort');
    var sort = currentSort();
    if (sel && sort) sel.value = sort;
  }

  function listingPageSize() {
    return readGridMeta(document).pageSize || cfPageSize || 60;
  }

  function paintPagerAndAmount(page, total) {
    var size = listingPageSize();
    cfPageSize = size;
    paintAmount(amountHtml(page, size, total || 0));
    var pager = document.getElementById('pagination');
    if (!pager) return;
    // Nothing found: the bottom toolbar would only repeat "Showing 0 to 0 of 0 items".
    pager.classList.toggle('cf-pager-empty', !total);
    var pages = Math.max(1, Math.ceil((total || 0) / size));
    var pagesHtml = buildCfPagerHtml(page, pages);
    var pagesEl = pager.querySelector('.pages.ajax_pagination');
    if (pagesEl) {
      if (pagesHtml) pagesEl.outerHTML = pagesHtml;
      else pagesEl.innerHTML = '';
    } else if (pagesHtml) {
      pager.insertAdjacentHTML('beforeend', pagesHtml);
    }
  }

  function paintGridPage(cards, page) {
    var grid = document.querySelector('.grid-real');
    if (!grid) return;
    var size = listingPageSize();
    cfPageSize = size;
    var start = (page - 1) * size;
    var slice = (cards || []).slice(start, start + size);
    // Cards already on screen are kept (same node: loaded images, hover state, slot locks).
    // Same cards in the same order -> the grid is not touched at all (strict search first paint).
    var onScreen = {};
    var onScreenOrder = [];
    Array.prototype.forEach.call(grid.children, function (node) {
      var h = node.classList.contains('product-layout') && !node.classList.contains('skeleton-item') ? cardProductHandle(node) : '';
      if (h && !onScreen[h]) onScreen[h] = node;
      onScreenOrder.push(h);
    });
    var sliceHandles = slice.map(cardProductHandle);
    if (slice.length && sliceHandles.join('\n') === onScreenOrder.join('\n')) {
      paintPagerAndAmount(page, (cards || []).length);
      return;
    }
    var nodes = slice.map(function (card, i) {
      var kept = sliceHandles[i] && onScreen[sliceHandles[i]];
      if (kept) delete onScreen[sliceHandles[i]];
      return kept || card.cloneNode(true);
    });
    grid.innerHTML = '';
    if (!slice.length) {
      var wrap = document.querySelector('.custom-category');
      var empty = document.createElement('div');
      empty.className = 'cf-empty';
      empty.innerHTML = '<h2></h2>';
      empty.firstChild.textContent = (wrap && wrap.getAttribute('data-cf-empty')) || 'Nothing found';
      grid.appendChild(empty);
    }
    nodes.forEach(function (node) {
      grid.appendChild(node);
    });
    restyleGridCards();
    paintPagerAndAmount(page, (cards || []).length);
    if (window.category_view && typeof category_view.afterGridHtmlChanged === 'function') {
      category_view.afterGridHtmlChanged(false);
    }
  }

  function beginGridWait() {
    setCfLoading(false);
    showGridSkeletons(listingPageSize());
  }

  function showGridSkeletons(count) {
    var grid = document.querySelector('.grid-real');
    if (!grid) return;
    var cols = targetColClasses();
    var n = count || listingPageSize();
    var html = '';
    var i;
    for (i = 0; i < n; i += 1) {
      html += '<div class="product-layout product-grid module-style1 skeleton-item ' + cols + '">'
        + '<div class="product-thumb"><div class="item"><div class="item-inner">'
        + '<div class="image images-container"><div class="oc-loading"></div></div>'
        + '<div class="caption"><h4 class="product-name"><span class="skeleton-bar skeleton-bar--title"></span></h4>'
        + '<div class="price-box"><p class="regular-price"><span class="price"><span class="skeleton-bar skeleton-bar--price"></span></span></p></div></div>'
        + '</div></div></div></div>';
    }
    grid.innerHTML = html;
  }

  function loadUnfilteredPage(page) {
    cfSnapshot = null;
    cfMergedCards = [];
    cfGridFiltered = false;
    cfGridPage = page;
    setCfLoading(false);
    var gen = (cfPageLoadGen += 1);
    var ready = readyOrderedCards();
    if (ready && ready.length) {
      paintGridPage(ready, page);
      scrollToProductGrid();
      return Promise.resolve();
    }
    if (restoreInitialView(page)) {
      scrollToProductGrid();
      prefetchNeighbourPages(page);
      return Promise.resolve();
    }
    // Without the listing in memory, fetch just this page and swap the cards in when it arrives.
    // The current cards stay under the theme spinner; image placeholders cover the rest.
    showSoftLoading();
    scrollToProductGrid();
    return pageDoc(page).then(function (doc) {
      if (gen !== cfPageLoadGen) return;
      fillGridFromDoc(doc, page);
      prefetchNeighbourPages(page);
    }).catch(function () {
      if (gen !== cfPageLoadGen) return;
      showGridSkeletons(listingPageSize());
      return fetchOrderedCards().then(function (cards) {
        if (gen !== cfPageLoadGen) return;
        paintGridPage(cards, page);
      });
    }).then(function () {
      if (gen === cfPageLoadGen) setCfLoading(false);
    });
  }

  // Parsed listing pages, shared by pagination, neighbour prefetch and the full-listing load.
  var cfPageDocs = {};

  function pageDoc(page, sort) {
    if (sort == null) sort = currentSort();
    var key = listingCacheKey() + '|' + sort + '#' + page;
    if (!cfPageDocs[key]) {
      cfPageDocs[key] = fetchListingPageDoc(page, sort).catch(function (err) {
        delete cfPageDocs[key];
        throw err;
      });
    }
    return cfPageDocs[key];
  }

  function prefetchNeighbourPages(page) {
    if (readyOrderedCards()) return;
    var meta = readGridMeta(document);
    var pages = Math.max(1, Math.ceil((meta.total || 0) / listingPageSize()));
    whenIdle(function () {
      [page + 1, page - 1].forEach(function (p) {
        if (p >= 1 && p <= pages) pageDoc(p).catch(function () {});
      });
    });
  }

  function hasAnyFilter(handles, stones, mf) {
    return !!(handles.length || stones.length || hasMf(mf));
  }

  function applyPaginationPage(page, push) {
    setPageInUrl(page, push);
    var handles = cfHandlesFromUrl();
    var stones = cfStonesFromUrl();
    var mf = cfMetafieldsFromUrl();
    if (hasAnyFilter(handles, stones, mf) || isSearchPage()) {
      if (cfMergedCards.length) renderMergedPage(page);
      else loadFilteredGrid(handles, stones, mf, page);
      scrollToProductGrid();
      return;
    }
    loadUnfilteredPage(page);
    if (push) warmListing();
  }

  // The first page click shows the visitor is browsing: load the whole listing in the background so further
  // paging (and Back) comes from memory. Visitors who never page don't download the catalog.
  var cfListingWarm = false;

  function warmListing() {
    if (cfListingWarm) return;
    cfListingWarm = true;
    whenIdle(function () {
      fetchOrderedCards().catch(function () {
        cfListingWarm = false;
      });
    });
  }

  function harvestGridCards(root, cards, seen) {
    var nodes = (root || document).querySelectorAll('.grid-real .product-layout');
    Array.prototype.forEach.call(nodes, function (card) {
      var id = cardProductHandle(card);
      if (!id || seen[id]) return;
      seen[id] = true;
      cards.push(card.cloneNode(true));
    });
  }

  function harvestPageCards(root, pageNum, buckets, seen) {
    var list = buckets[pageNum] || [];
    harvestGridCards(root, list, seen);
    buckets[pageNum] = list;
  }

  function flattenCardBuckets(buckets) {
    var cards = [];
    Object.keys(buckets).map(Number).sort(function (a, b) { return a - b; }).forEach(function (p) {
      (buckets[p] || []).forEach(function (c) { cards.push(c); });
    });
    return cards;
  }

  function captureInitialCards() {
    if (cfHandlesFromUrl().length || !document.querySelector('.grid-real')) return;
    var cards = [];
    harvestGridCards(document, cards, {});
    cfInitialCards = { page: currentPageNum(), sort: currentSort(), cards: cards };
    var pager = document.getElementById('pagination');
    cfInitialView = {
      page: cfInitialCards.page,
      sort: cfInitialCards.sort,
      grid: document.querySelector('.grid-real').innerHTML,
      pager: pager ? pager.innerHTML : '',
      amounts: Array.prototype.map.call(document.querySelectorAll('.toolbar-amount'), function (el) { return el.innerHTML; })
    };
  }

  // Back to the page the server rendered: put its markup back instead of fetching it again.
  function restoreInitialView(page) {
    var v = cfInitialView;
    if (!v || v.page !== page || v.sort !== currentSort()) return false;
    var grid = document.querySelector('.grid-real');
    if (!grid) return false;
    grid.innerHTML = v.grid;
    var pager = document.getElementById('pagination');
    if (pager) { pager.classList.remove('cf-pager-empty'); pager.innerHTML = v.pager; }
    document.querySelectorAll('.toolbar-amount').forEach(function (el, i) {
      if (v.amounts[i] != null) el.innerHTML = v.amounts[i];
    });
    restyleGridCards();
    if (window.category_view && typeof category_view.afterGridHtmlChanged === 'function') {
      category_view.afterGridHtmlChanged(false);
    }
    return true;
  }

  // Puts the server-rendered page into buckets. Returns its page number, or 0 when there is nothing to reuse.
  function seedFromInitialCards(buckets, seen, sort) {
    if (!cfInitialCards || cfInitialCards.sort !== sort) return 0;
    var list = [];
    cfInitialCards.cards.forEach(function (card) {
      var id = cardProductHandle(card);
      if (!id || seen[id]) return;
      seen[id] = true;
      list.push(card.cloneNode(true));
    });
    buckets[cfInitialCards.page] = list;
    return cfInitialCards.page;
  }

  function currentPageNum() {
    try {
      return parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10) || 1;
    } catch (e) {
      return 1;
    }
  }

  function readGridMeta(root) {
    var wrap = (root || document).querySelector('.custom-category');
    var total = wrap ? parseInt(wrap.getAttribute('data-cf-total') || '0', 10) : 0;
    var size = wrap ? parseInt(wrap.getAttribute('data-cf-page-size') || '0', 10) : 0;
    if (!total) {
      var amount = (root || document).querySelector('.toolbar-amount');
      var m = amount && (amount.textContent || '').match(/of\s+(\d+)/i);
      if (m) total = parseInt(m[1], 10);
    }
    return { total: total, pageSize: size || cfPageSize || 60 };
  }

  // Every card of the current listing (All products or the search results). Filters and counts both work on it,
  // so a collection filter is "product is in this collection" everywhere, the same as the other groups.
  function fetchListingCards() {
    var key = listingCacheKey();
    if (cfCardCache[key]) return cfCardCache[key];
    var membership = fetchMembership();
    var sort = currentSort();
    cfUniverseSort[key] = sort;
    var buckets = {};
    var seen = {};
    var meta = readGridMeta(document);
    var skipPage = seedFromInitialCards(buckets, seen, sort);

    function harvest(p) {
      return pageDoc(p, sort).then(function (doc) {
        harvestPageCards(doc, p, buckets, seen);
        return doc;
      });
    }

    function next(p) {
      return harvest(p).then(function (doc) {
        var nextLink = doc.querySelector('#pagination a[href*="page=' + (p + 1) + '"]');
        return nextLink ? next(p + 1) : null;
      });
    }

    var work;
    if (meta.total) {
      var jobs = [];
      var pages = Math.max(1, Math.ceil(meta.total / meta.pageSize));
      for (var p = 1; p <= pages; p += 1) {
        if (p !== skipPage) jobs.push(harvest(p));
      }
      work = Promise.all(jobs);
    } else {
      work = next(1);
    }

    cfCardCache[key] = Promise.all([work, membership]).then(function (res) {
      var cards = strictSearchCards(flattenCardBuckets(buckets));
      applyMembership(cards, res[1]);
      if (isSearchPage()) paintSearchTitle(cards.length);
      cfResolvedCards[key] = cards;
      cfPageDocs = {};
      return cards;
    }, function (err) {
      delete cfCardCache[key];
      throw err;
    });
    return cfCardCache[key];
  }

  function itemCountLabel(n) {
    if (n === 0) return '0 item';
    return n === 1 ? '1 item' : (n + ' items');
  }

  function setFilterCount(node, n) {
    if (!node) return;
    var span = node.querySelector('.cf-filter-count');
    var label = itemCountLabel(n);
    if (span) {
      span.removeAttribute('data-cf-count-pending');
      span.textContent = label;
      return;
    }
    var text = node.textContent || '';
    if (/\([^)]*\)\s*$/.test(text)) node.textContent = text.replace(/\([^)]*\)\s*$/, '(' + label + ')');
    else node.textContent = text.replace(/\s+$/, '') + ' (' + label + ')';
  }

  function cardStoneList(card) {
    var vals = (card.getAttribute('data-cf-stones') || '').split(/\s+/).filter(Boolean);
    var list = vals.filter(function (v) { return v && v !== 'without-stones'; });
    if (cardGemHandle(card) !== 'has-gem') list.push('without-stones');
    return list;
  }

  function cardMfValues(card, k) {
    return (card.getAttribute('data-cf-mf-' + k) || '').split(/\s+/).filter(Boolean);
  }

  function cardCollections(card) {
    return (card.getAttribute('data-cf-collections') || '').split(/\s+/).filter(Boolean);
  }

  function bumpEach(counts, values, prefix) {
    var uniq = {};
    values.forEach(function (v) { uniq[v] = true; });
    Object.keys(uniq).forEach(function (v) {
      var k = prefix + v;
      counts[k] = (counts[k] || 0) + 1;
    });
  }

  // Faceted counts: a value's number is how many products would match if it were ticked
  // on top of the current selection in every other group. Within its own group values are OR,
  // so that group's own selection is ignored for its counts.
  function facetCounts(cards, sel) {
    var out = { collections: {}, stones: {}, mf: { _total: 0 } };
    var seen = {};
    (cards || []).forEach(function (card) {
      var key = cardProductHandle(card);
      if (!key || seen[key]) return;
      seen[key] = true;
      var ok = { st: cardMatchesStones(card, sel.st) };
      CF_COLLECTION_GROUPS.forEach(function (g) {
        ok[g] = cardInAny(card, handlesInGroup(sel.cf, g));
      });
      MF_KEYS.forEach(function (k) { ok[k] = cardMatchesMfKey(card, k, sel.mf[k]); });
      function passesExcept(group) {
        for (var g in ok) {
          if (g !== group && !ok[g]) return false;
        }
        return true;
      }
      var inCols = {};
      cardCollections(card).forEach(function (h) { inCols[h] = true; });
      Object.keys(inCols).forEach(function (h) {
        if (passesExcept(collectionGroup(h))) out.collections[h] = (out.collections[h] || 0) + 1;
      });
      if (passesExcept('st')) bumpEach(out.stones, cardStoneList(card), '');
      MF_KEYS.forEach(function (k) {
        if (!passesExcept(k)) return;
        if (k === 'with_gemstones') {
          out.mf._total += 1;
          bumpEach(out.mf, [cardGemHandle(card)], k + '\t');
        } else {
          bumpEach(out.mf, cardMfValues(card, k), k + '\t');
        }
      });
    });
    return out;
  }

  function syncCollectionCountLabels(counts) {
    if (!counts) return;
    filterRoots().forEach(function (root) {
      root.querySelectorAll('[data-cf-handle]').forEach(function (node) {
        if (!node.querySelector('.cf-filter-count')) return;
        setFilterCount(node, counts[node.getAttribute('data-cf-handle')] || 0);
      });
    });
  }

  function syncStoneCountLabels(counts) {
    if (!counts) return;
    filterRoots().forEach(function (root) {
      root.querySelectorAll('[data-cf-stone]').forEach(function (node) {
        var v = node.getAttribute('data-cf-stone');
        if (!v) return;
        setFilterCount(node, counts[v] || 0);
      });
    });
  }

  function syncMfCountLabels(counts) {
    if (!counts) return;
    filterRoots().forEach(function (root) {
      root.querySelectorAll('[data-cf-mf-key][data-cf-mf-value]').forEach(function (node) {
        var k = node.getAttribute('data-cf-mf-key');
        var v = node.getAttribute('data-cf-mf-value');
        if (!k || v == null) return;
        var n = 0;
        if (k === 'with_gemstones' && (v === 'all' || v === 'all-gem')) n = counts._total || 0;
        else n = counts[k + '\t' + v] || 0;
        setFilterCount(node, n);
      });
    });
  }

  function paintFilterCounts(counts) {
    syncCollectionCountLabels(counts.collections);
    syncStoneCountLabels(counts.stones);
    syncMfCountLabels(counts.mf);
    // How many times counts were painted: lets tests (tests/specs/filters.spec.ts) wait for real numbers.
    document.body.setAttribute('data-cf-counts', String((parseInt(document.body.getAttribute('data-cf-counts'), 10) || 0) + 1));
  }

  // Counts with nothing selected are cached for the tab, so repeat visits show them without refetching every page.
  function countsStorageKey() {
    var id = isSearchPage()
      ? 'search:' + (new URL(window.location.href).searchParams.get('q') || '')
      : currentAllHandle();
    return 'cfCounts8:' + id + ':' + readGridMeta(document).total;
  }

  // Counts with nothing ticked are kept for a day, so a repeat visit paints them (and arranges the collection
  // columns) at once instead of after the listing loads. Saved counts older than CF_COUNTS_RECHECK are painted
  // and then recounted in the background, so edits in the admin show up within minutes, not a day.
  var CF_COUNTS_TTL = 24 * 60 * 60 * 1000;
  var CF_COUNTS_RECHECK = 10 * 60 * 1000;

  // Shopify's own counts for the metafield groups (collection-filter-groups.liquid, #cf-native-counts): the whole
  // listing with nothing ticked, always fresh. Not printed on search.
  var cfNativeCounts;

  function nativeMfCounts() {
    if (cfNativeCounts !== undefined) return cfNativeCounts;
    cfNativeCounts = null;
    // A URL with Shopify's own filter params (filter.p.…, filter.v.…) narrows collection.filters, so its counts are
    // not the whole listing any more.
    if (/[?&]filter\./.test(window.location.search)) return cfNativeCounts;
    try {
      var el = document.getElementById('cf-native-counts');
      if (el) cfNativeCounts = JSON.parse(el.textContent);
    } catch (e) {}
    return cfNativeCounts;
  }

  function nativeGroups(native) {
    var groups = {};
    Object.keys(native).forEach(function (k) { groups[k.split('\t')[0]] = true; });
    return groups;
  }

  // Nothing ticked: Shopify's numbers replace ours for every group it reports.
  function withNativeMf(counts) {
    var native = nativeMfCounts();
    if (!native || !counts || !counts.mf) return counts;
    var groups = nativeGroups(native);
    var mf = {};
    Object.keys(counts.mf).forEach(function (k) {
      if (!groups[k.split('\t')[0]]) mf[k] = counts.mf[k];
    });
    Object.keys(native).forEach(function (k) { mf[k] = native[k]; });
    var out = {};
    Object.keys(counts).forEach(function (k) { out[k] = counts[k]; });
    out.mf = mf;
    return out;
  }

  // Before anything is loaded or cached: paint just the groups Shopify reported.
  function paintNativeMfCounts() {
    var native = nativeMfCounts();
    if (!native) return;
    var groups = nativeGroups(native);
    filterRoots().forEach(function (root) {
      root.querySelectorAll('[data-cf-mf-key][data-cf-mf-value]').forEach(function (node) {
        var k = node.getAttribute('data-cf-mf-key');
        if (!groups[k]) return;
        setFilterCount(node, native[k + '\t' + node.getAttribute('data-cf-mf-value')] || 0);
      });
    });
  }

  // Paints the saved counts; returns them (with savedAt) or null.
  function restoreSavedCounts() {
    try {
      var c = JSON.parse(localStorage.getItem(countsStorageKey()) || 'null');
      if (c && c.savedAt && Date.now() - c.savedAt > CF_COUNTS_TTL) {
        localStorage.removeItem(countsStorageKey());
        return null;
      }
      if (c && c.collections && c.stones && c.mf) {
        paintFilterCounts(withNativeMf(c));
        arrangeRestByCounts(c.collections);
        return c;
      }
    } catch (e) {}
    return null;
  }

  function saveCounts(counts) {
    try {
      counts.savedAt = Date.now();
      localStorage.setItem(countsStorageKey(), JSON.stringify(counts));
    } catch (e) {}
  }

  function countsVisible() {
    var p = panel();
    if (p && p.classList.contains('is-open')) return true;
    var side = document.querySelector('.layernavigation-module .cf-filter-groups');
    return !!(side && side.offsetParent !== null);
  }

  // The ticked (not necessarily applied) selection, so counts react to every click before Apply.
  function currentSelection() {
    var source = panel() || document.querySelector('.layernavigation-module');
    return {
      cf: selectedHandles(source),
      st: selectedStones(source),
      mf: selectedMetafields(source)
    };
  }

  // First load, nothing ticked: the Collections column goes most products of this listing first and drops the empty
  // ones (collection pages and search). The custom category and Promo keep every entry in the settings' order.
  // Done once, so nothing moves or disappears while the visitor clicks.
  var cfRestArranged = false;

  function hideIfEmpty(a, colCounts) {
    var n = colCounts[a.getAttribute('data-cf-handle')] || 0;
    a.classList.toggle('cf-col-empty', !n && !a.classList.contains('active-filter'));
  }

  function arrangeRestByCounts(colCounts) {
    if (cfRestArranged || !colCounts) return;
    cfRestArranged = true;
    document.querySelectorAll('.cf-col-rest').forEach(function (rest) {
      var links = Array.prototype.slice.call(rest.querySelectorAll('a.add-filter[data-cf-handle]'));
      var pos = new Map();
      links.forEach(function (a, i) { pos.set(a, i); });
      function n(a) { return colCounts[a.getAttribute('data-cf-handle')] || 0; }
      links.sort(function (a, b) { return n(b) - n(a) || pos.get(a) - pos.get(b); });
      links.forEach(function (a) {
        hideIfEmpty(a, colCounts);
        rest.appendChild(a);
      });
      var more = rest.querySelector('.cf-more-toggle');
      if (more) rest.appendChild(more);
    });
    document.querySelectorAll('.cf-collection-list').forEach(function (list) {
      if (list.querySelector('a.add-filter[data-cf-handle]:not(.cf-col-empty)')) return;
      var box = list.closest('.filter-attribute-container');
      if (box) box.hidden = true;
    });
    refreshRestToggles();
  }

  var cfCountsGen = 0;

  function refreshFilterCounts() {
    if (!cfContext()) return;
    var sel = currentSelection();
    var empty = !hasAnyFilter(sel.cf, sel.st, sel.mf);
    var gen = (cfCountsGen += 1);
    // The tab cache only stands in for a listing that is not loaded yet. Search always loads its strict
    // listing anyway, and its matching rules may change, so search never reads the cache.
    var loaded = !!cfResolvedCards[listingCacheKey()];
    if (empty && !loaded && !isSearchPage()) {
      var saved = restoreSavedCounts();
      if (saved && Date.now() - saved.savedAt < CF_COUNTS_RECHECK) return;
      if (!saved) paintNativeMfCounts();
    }
    function run() {
      fetchListingCards().then(function (cards) {
        if (gen !== cfCountsGen) return;
        var counts = facetCounts(cards, sel);
        paintFilterCounts(empty && !isSearchPage() ? withNativeMf(counts) : counts);
        if (empty) arrangeRestByCounts(counts.collections);
        if (empty && !isSearchPage()) saveCounts(counts);
      }).catch(function () {});
    }
    if (cfResolvedCards[listingCacheKey()]) run();
    else whenIdle(run);
  }

  // Background work starts only after window load: grid-item.js reveals the grid on load, and on a slow
  // connection our page fetches would otherwise take bandwidth from the card images and hold the skeletons longer.
  function whenIdle(fn) {
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
      else window.setTimeout(fn, 300);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  function renderMergedPage(page) {
    paintGridPage(cfMergedCards, page);
  }

  function buildCfPagerHtml(page, pages) {
    if (pages <= 1) return '';
    function pageItem(i) {
      if (i === page) return '<li class="active"><span>' + i + '</span></li>';
      return '<li><a href="?page=' + i + '" data-cf-page="' + i + '">' + i + '</a></li>';
    }
    var links = '';
    if (page > 1) {
      links += '<li><a href="?page=' + (page - 1) + '" data-cf-page="' + (page - 1) + '" title="Previous">&lt;</a></li>';
    }
    var nums = [];
    function addPage(n) {
      if (n >= 1 && n <= pages && nums.indexOf(n) === -1) nums.push(n);
    }
    addPage(1);
    for (var j = page - 2; j <= page + 2; j += 1) addPage(j);
    addPage(pages);
    nums.sort(function (a, b) { return a - b; });
    var prevNum = 0;
    nums.forEach(function (n) {
      if (prevNum && n - prevNum > 1) links += '<li>&hellip;</li>';
      links += pageItem(n);
      prevNum = n;
    });
    if (page < pages) {
      links += '<li class="pagination-next"><a href="?page=' + (page + 1) + '" data-cf-page="' + (page + 1) + '" title="Next">&gt;</a></li>';
    }
    return '<div class="pages ajax_pagination"><ul class="pagination">' + links + '</ul></div>';
  }

  function currentAllHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/]+)/);
    return m ? decodeURIComponent(m[1]) : 'all-products';
  }

  function cardMatchesStones(card, stones) {
    if (!stones || !stones.length) return true;
    var vals = cardStoneList(card);
    return stones.some(function (s) { return vals.indexOf(s) !== -1; });
  }

  // Catalog and promo handles, set by reorderFilterLists. Catalog, promo and the other collections
  // are three groups: OR inside a group, AND between them (Rings + On sale = rings on sale).
  var cfCatalog = [];
  var cfPromo = [];
  var CF_COLLECTION_GROUPS = ['cat', 'promo', 'col'];

  function collectionGroup(handle) {
    if (cfPromo.indexOf(handle) !== -1) return 'promo';
    return cfCatalog.indexOf(handle) !== -1 ? 'cat' : 'col';
  }

  function handlesInGroup(handles, group) {
    return (handles || []).filter(function (h) { return collectionGroup(h) === group; });
  }

  function cardInAny(card, handles) {
    if (!handles || !handles.length) return true;
    var vals = cardCollections(card);
    return handles.some(function (h) { return vals.indexOf(h) !== -1; });
  }

  function cardMatchesCollections(card, handles) {
    if (!handles || !handles.length) return true;
    return CF_COLLECTION_GROUPS.every(function (g) {
      return cardInAny(card, handlesInGroup(handles, g));
    });
  }

  function cardGemHandle(card) {
    var vals = cardMfValues(card, 'with_gemstones');
    if (vals.indexOf('has-gem') !== -1 || vals.indexOf('true') !== -1) return 'has-gem';
    return 'no-gem';
  }

  function cardMatchesMfKey(card, k, wanted) {
    if (!wanted || !wanted.length) return true;
    if (k === 'with_gemstones') {
      var gem = cardGemHandle(card);
      return wanted.some(function (v) {
        if (isGemAllValue(v)) return true;
        if (v === 'has-gem' || v === 'true') return gem === 'has-gem';
        if (v === 'no-gem' || v === 'false') return gem === 'no-gem';
        return false;
      });
    }
    var vals = cardMfValues(card, k);
    return wanted.some(function (v) { return vals.indexOf(v) !== -1; });
  }

  function cardMatchesMf(card, mf) {
    if (!hasMf(mf)) return true;
    return MF_KEYS.every(function (k) { return cardMatchesMfKey(card, k, mf[k]); });
  }

  // OR inside a group, AND between groups.
  // quiet keeps the current cards on screen while the listing loads (first paint of strict search).
  function loadFilteredGrid(colHandles, stones, mf, page, quiet) {
    markGridFiltered();
    if (quiet || cfResolvedCards[listingCacheKey()]) showSoftLoading();
    else beginGridWait();
    var gen = (cfPageLoadGen += 1);
    return fetchOrderedCards().then(function (cards) {
      if (gen !== cfPageLoadGen) return;
      cfMergedCards = cards.filter(function (card) {
        return cardMatchesCollections(card, colHandles)
          && cardMatchesStones(card, stones)
          && cardMatchesMf(card, mf);
      });
      renderMergedPage(page || 1);
    }).catch(function () {
      if (gen === cfPageLoadGen) restoreGrid();
    }).then(function () {
      setCfLoading(false);
    });
  }

  function applyCfToGrid(handles, stones, mf) {
    var page = currentPageNum();
    stones = stones || cfStonesFromUrl();
    mf = mf || cfMetafieldsFromUrl();
    if (!hasAnyFilter(handles, stones, mf) && !isSearchPage()) {
      if (!cfGridFiltered) return;
      if (cfSnapshot && cfSnapshot.page === page) restoreGrid();
      else loadUnfilteredPage(page);
      return;
    }
    loadFilteredGrid(handles, stones, mf, page);
  }

  function setCfUrl(handles, stones, mf) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (handles.length) url.searchParams.set('cf', handles.join(' '));
    else url.searchParams.delete('cf');
    if (stones && stones.length) url.searchParams.set('st', stones.join(' '));
    else url.searchParams.delete('st');
    mf = mf || {};
    MF_KEYS.forEach(function (k) {
      var vals = mf[k] && mf[k].length ? mf[k].slice() : [];
      if (k === 'with_gemstones') vals = vals.filter(function (v) { return !isGemAllValue(v); });
      if (vals.length) url.searchParams.set(k, vals.join(' '));
      else url.searchParams.delete(k);
    });
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', url.toString());
    }
  }

  function applyCf(handles, stones, mf) {
    stones = stones || selectedStones(panel());
    mf = mf || selectedMetafields(panel());
    setCfUrl(handles, stones, mf);
    applyCfToGrid(handles, stones, mf);
    syncAllChecks(handles, stones, mf);
    renderChips();
  }

  // Chips under the toolbar: one per applied value (from the URL), with a cross to drop it.
  function cssValue(v) {
    return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&');
  }

  function filterNodeFor(selector) {
    var roots = filterRoots();
    for (var i = 0; i < roots.length; i++) {
      var node = roots[i].querySelector(selector);
      if (node) return node;
    }
    return null;
  }

  function nodeLabel(node, fallback) {
    var label = node && (node.querySelector('.cf-filter-label') || node);
    var text = label ? (label.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return text || fallback;
  }

  // Section a value comes from, for its chip: "Gemstone: White", "Promo: On Sale". Search headings read
  // "In …" (In Category, In Promo); the chip drops that prefix.
  function plainTitle(text) {
    return (text || '').replace(/\s+/g, ' ').trim().replace(/^(in|dans)\s+(les?\s+|la\s+)?/i, '');
  }

  function groupTitle(node) {
    var box = node && node.closest('.filter-attribute-container');
    var label = box && box.querySelector(':scope > label');
    return label ? plainTitle(label.textContent) : '';
  }

  function collectionTitle(node, handle) {
    var list = node && node.closest('.cf-collection-list');
    if (!list) return '';
    var attr = { cat: 'data-featured-title', promo: 'data-promo-title', col: 'data-thematic-title' }[collectionGroup(handle)];
    return plainTitle(list.getAttribute(attr));
  }

  function withTitle(title, label) {
    return title ? title + ': ' + label : label;
  }

  function chipEntries() {
    var out = [];
    cfHandlesFromUrl().forEach(function (h) {
      var node = filterNodeFor('[data-cf-handle="' + cssValue(h) + '"]');
      out.push({ kind: 'cf', value: h, label: withTitle(collectionTitle(node, h), nodeLabel(node, h)) });
    });
    cfStonesFromUrl().forEach(function (v) {
      var node = filterNodeFor('[data-cf-stone="' + cssValue(v) + '"]');
      out.push({ kind: 'st', value: v, label: withTitle(groupTitle(node), nodeLabel(node, v)) });
    });
    var mf = cfMetafieldsFromUrl();
    MF_KEYS.forEach(function (k) {
      (mf[k] || []).forEach(function (v) {
        var node = filterNodeFor('[data-cf-mf-key="' + k + '"][data-cf-mf-value="' + cssValue(v) + '"]');
        var title = groupTitle(node) || (k === 'with_gemstones' ? 'Gemstones' : '');
        out.push({ kind: k, value: v, label: withTitle(title, nodeLabel(node, v)) });
      });
    });
    return out;
  }

  function renderChips() {
    var boxes = document.querySelectorAll('[data-cf-chips]');
    if (!boxes.length) return;
    var items = chipEntries();
    boxes.forEach(function (box) {
      box.innerHTML = '';
      items.forEach(function (it) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cf-chip';
        chip.setAttribute('data-cf-chip-kind', it.kind);
        chip.setAttribute('data-cf-chip-value', it.value);
        chip.setAttribute('aria-label', it.label + ' \u00d7');
        var text = document.createElement('span');
        text.className = 'cf-chip__label';
        text.textContent = it.label;
        var x = document.createElement('span');
        x.className = 'cf-chip__x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '\u00d7';
        chip.appendChild(text);
        chip.appendChild(x);
        box.appendChild(chip);
      });
      if (items.length > 1) {
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'cf-chip cf-chip--clear';
        clear.setAttribute('data-cf-chip-clear', '');
        clear.textContent = box.getAttribute('data-clear-label') || 'Clear';
        box.appendChild(clear);
      }
      box.hidden = !items.length;
    });
  }

  function removeChip(kind, value) {
    var handles = cfHandlesFromUrl();
    var stones = cfStonesFromUrl();
    var mf = cfMetafieldsFromUrl();
    function without(list) { return (list || []).filter(function (v) { return v !== value; }); }
    if (kind === 'cf') handles = without(handles);
    else if (kind === 'st') stones = without(stones);
    else mf[kind] = without(mf[kind]);
    applyCf(handles, stones, mf);
  }

  function navigateCf(handles, stones, mf) {
    applyCf(handles, stones, mf);
    closePanel();
  }

  function reorderFilterLists() {
    if (window.cfCollectionGroups) {
      var groups = window.cfCollectionGroups();
      cfCatalog = groups.catalog;
      cfPromo = groups.promo;
    }
    if (window.cfReorderCollectionLists) {
      document.querySelectorAll('.cf-collection-list').forEach(function (listRoot) {
        window.cfReorderCollectionLists(listRoot);
      });
    }
    arrangePanelColumns();
    refreshRestToggles();
  }

  // Modal layout: Category heads the first column, above the custom category and Promo; Collections fill the rest
  // of the top row and every other group gets its own cell of the grid below (custom.css.liquid).
  // With a Collections column (All products, search): Category goes to the top of the first column.
  // Without it (a regular collection page): Category, custom category and Promo sit side by side in a top row
  // (.cf-panel-top, custom.css.liquid), with the other groups below.
  function arrangePanelColumns() {
    var p = panel();
    if (!p) return;
    var cat = p.querySelector('.filter-category');
    var col = p.querySelector('.cf-col-catalog');
    var box = col && col.closest('.filter-categories');
    if (col && p.querySelector('.cf-col-rest')) {
      if (cat && col.firstChild !== cat) col.insertBefore(cat, col.firstChild);
      return;
    }
    if (!box || box.hidden) return;
    var top = p.querySelector('.cf-panel-top');
    if (!top) {
      top = document.createElement('div');
      top.className = 'cf-panel-top';
      box.parentNode.insertBefore(top, box);
    }
    if (cat && cat.parentNode !== top) top.insertBefore(cat, top.firstChild);
    if (box.parentNode !== top) top.appendChild(box);
  }

  function panelRestLimit() {
    if (window.matchMedia('(min-width: 992px)').matches) return 0;
    if (window.matchMedia('(min-width: 768px)').matches) return 24;
    return 12;
  }

  function toggleLabels(el) {
    var host = el.closest('[data-show-more]') || el;
    return {
      more: host.getAttribute('data-show-more') || 'Show more',
      less: host.getAttribute('data-show-less') || 'Show less'
    };
  }

  function applyRestCollapse(wrap, items, limit) {
    var labels = toggleLabels(wrap);
    var btn = wrap.querySelector('.cf-more-toggle');
    if (!limit || items.length <= limit) {
      items.forEach(function (a) { a.classList.remove('cf-rest-extra'); });
      if (btn) btn.hidden = true;
      wrap.classList.remove('is-collapsed', 'is-expanded');
      return;
    }
    if (!wrap.classList.contains('is-expanded')) wrap.classList.add('is-collapsed');
    var collapsed = wrap.classList.contains('is-collapsed');
    items.forEach(function (a, i) {
      a.classList.toggle('cf-rest-extra', collapsed && i >= limit);
    });
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-more-toggle';
    }
    wrap.appendChild(btn);
    btn.hidden = false;
    btn.textContent = collapsed ? labels.more : labels.less;
  }

  function refreshRestToggles() {
    document.querySelectorAll('.cf-collection-list').forEach(function (listRoot) {
      var rest = listRoot.querySelector('.cf-col-rest');
      if (!rest) return;
      var raw = listRoot.getAttribute('data-rest-limit');
      var limit = raw == null || raw === '' ? panelRestLimit() : (parseInt(raw, 10) || 0);
      applyRestCollapse(
        rest,
        Array.prototype.slice.call(rest.querySelectorAll('a.add-filter:not(.cf-col-empty)')),
        limit
      );
    });
  }

  function initCf() {
    setCfLoading(false);
    reorderFilterLists();
    if (!cfContext()) return;
    var handles = cfHandlesFromUrl();
    var stones = cfStonesFromUrl();
    var mf = cfMetafieldsFromUrl();
    syncSortSelect();
    watchSideActions();
    captureInitialCards();
    cfGridFiltered = handles.length > 0;
    cfGridPage = currentPageNum();
    syncAllChecks(handles, stones, mf);
    renderChips();
    if (isSearchPage() && !hasAnyFilter(handles, stones, mf)) {
      hideLooseSearchCards();
      loadFilteredGrid([], [], {}, cfGridPage, true);
    } else {
      applyCfToGrid(handles, stones, mf);
    }
    if (!cfGridFiltered) prefetchNeighbourPages(cfGridPage);
  }

  // Until the strict listing is ready, drop the loosely related cards from the server page.
  function hideLooseSearchCards() {
    var cards = document.querySelectorAll('.grid-real .product-layout');
    var strict = document.querySelectorAll('.grid-real .product-layout[data-cf-match="1"]');
    if (!strict.length) return;
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-cf-match') !== '1') card.parentNode.removeChild(card);
    });
  }

  function isCfFilterControl(node) {
    return !!(node && node.closest && node.closest('#collection-filter-panel a.add-filter, .layernavigation-module .cf-filter-groups a.add-filter'));
  }

  document.addEventListener('contextmenu', function (e) {
    if (isCfFilterControl(e.target)) e.preventDefault();
  }, true);

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cf-chips] .cf-chip');
    if (chip) {
      e.preventDefault();
      if (chip.hasAttribute('data-cf-chip-clear')) applyCf([], [], {});
      else removeChip(chip.getAttribute('data-cf-chip-kind'), chip.getAttribute('data-cf-chip-value'));
      return;
    }
    var moreBtn = e.target.closest('.cf-more-toggle');
    if (moreBtn) {
      e.preventDefault();
      var wrap = moreBtn.closest('.cf-col-rest, .cf-side-rest');
      if (wrap) {
        if (wrap.classList.contains('is-collapsed')) {
          wrap.classList.remove('is-collapsed');
          wrap.classList.add('is-expanded');
        } else {
          wrap.classList.add('is-collapsed');
          wrap.classList.remove('is-expanded');
        }
        refreshRestToggles();
      }
      return;
    }
    if (e.target.closest('#toolbar-filter-btn')) {
      e.preventDefault();
      openPanel();
      return;
    }
    if (e.target.closest('[data-filter-close]')) {
      closePanel();
      return;
    }
    var panelLink = e.target.closest('#collection-filter-panel [data-cf-handle]');
    if (panelLink) {
      e.preventDefault();
      e.stopPropagation();
      togglePanelHandle(panelLink);
      return;
    }
    var stoneLink = e.target.closest('#collection-filter-panel [data-cf-stone]');
    if (stoneLink) {
      e.preventDefault();
      e.stopPropagation();
      var stoneVal = stoneLink.getAttribute('data-cf-stone');
      setCheckedMatch('[data-cf-stone="' + stoneVal + '"]', !stoneLink.classList.contains('active-filter'));
      updateApplyCount();
      return;
    }
    var mfLink = e.target.closest('#collection-filter-panel [data-cf-mf-value]');
    if (mfLink) {
      e.preventDefault();
      e.stopPropagation();
      var mfKey = mfLink.getAttribute('data-cf-mf-key');
      var mfVal = mfLink.getAttribute('data-cf-mf-value');
      if (mfKey === 'with_gemstones') {
        filterRoots().forEach(function (root) {
          root.querySelectorAll('[data-cf-mf-key="with_gemstones"]').forEach(function (node) {
            setChecked(node, node.getAttribute('data-cf-mf-value') === mfVal);
          });
        });
      } else {
        setCheckedMatch('[data-cf-mf-key="' + mfKey + '"][data-cf-mf-value="' + mfVal + '"]', !mfLink.classList.contains('active-filter'));
      }
      updateApplyCount();
      return;
    }
    if (e.target.closest('[data-filter-clear]')) {
      e.preventDefault();
      filterRoots().forEach(function (root) {
        root.querySelectorAll('[data-cf-handle], [data-cf-stone], [data-cf-mf-value]').forEach(function (link) {
          setChecked(link, false);
        });
      });
      syncGemstonesRadio({});
      updateApplyCount();
      applyCf([], [], {});
      if (!e.target.closest('#collection-filter-panel')) closePanel();
      return;
    }
    if (e.target.closest('[data-filter-apply]')) {
      e.preventDefault();
      var applySource = panel() || document.querySelector('.layernavigation-module');
      navigateCf(selectedHandles(applySource), selectedStones(applySource), selectedMetafields(applySource));
      return;
    }
    if (cfContext()) {
      var side = e.target.closest('.layernavigation-module .cf-filter-groups a.add-filter');
      if (side) {
        e.preventDefault();
        var sideHandle = side.getAttribute('data-cf-handle');
        var sideStone = side.getAttribute('data-cf-stone');
        var sideMfKey = side.getAttribute('data-cf-mf-key');
        var sideMfVal = side.getAttribute('data-cf-mf-value');
        if (sideMfKey === 'with_gemstones') {
          filterRoots().forEach(function (root) {
            root.querySelectorAll('[data-cf-mf-key="with_gemstones"]').forEach(function (node) {
              setChecked(node, node.getAttribute('data-cf-mf-value') === sideMfVal);
            });
          });
        } else if (sideMfKey && sideMfVal != null) {
          setCheckedMatch('[data-cf-mf-key="' + sideMfKey + '"][data-cf-mf-value="' + sideMfVal + '"]', !side.classList.contains('active-filter'));
        } else if (sideStone) {
          setCheckedMatch('[data-cf-stone="' + sideStone + '"]', !side.classList.contains('active-filter'));
        } else if (sideHandle) {
          setCheckedMatch('[data-cf-handle="' + sideHandle + '"]', !side.classList.contains('active-filter'));
        }
        updateApplyCount();
        return;
      }
    }
    var pageLink = e.target.closest('#pagination a');
    if (pageLink && document.querySelector('.grid-real')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var href = pageLink.getAttribute('href') || '';
      if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
        e.preventDefault();
        applyPaginationPage(pageFromPagerLink(pageLink), true);
      }
    }
  });

  window.addEventListener('popstate', function () {
    if (!document.querySelector('.grid-real') || !document.getElementById('pagination')) return;
    var path = window.location.pathname || '';
    var onListing = /\/collections\//.test(path) || /\/search/.test(path);
    if (!onListing) {
      window.location.reload();
      return;
    }
    syncSortSelect();
    cfMergedCards = [];
    applyPaginationPage(currentPageNum(), false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  var restResizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(restResizeTimer);
    restResizeTimer = window.setTimeout(refreshRestToggles, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCf);
  } else {
    initCf();
  }
})();